__turbopack_context__.v({
  "allGamesMessage": "sportschedule-module-scss-module__DjcIfq__allGamesMessage",
  "days": "sportschedule-module-scss-module__DjcIfq__days",
  "filterBar": "sportschedule-module-scss-module__DjcIfq__filterBar",
  "filterBarSelect": "sportschedule-module-scss-module__DjcIfq__filterBarSelect",
  "large": "sportschedule-module-scss-module__DjcIfq__large",
  "loadMoreGames": "sportschedule-module-scss-module__DjcIfq__loadMoreGames",
  "loadMoreMessage": "sportschedule-module-scss-module__DjcIfq__loadMoreMessage",
  "moreGames": "sportschedule-module-scss-module__DjcIfq__moreGames",
  "noGames": "sportschedule-module-scss-module__DjcIfq__noGames",
  "noGamesAnchor": "sportschedule-module-scss-module__DjcIfq__noGamesAnchor",
  "noGamesMsg": "sportschedule-module-scss-module__DjcIfq__noGamesMsg",
  "noGamesTitle": "sportschedule-module-scss-module__DjcIfq__noGamesTitle",
  "noGamesWrapper": "sportschedule-module-scss-module__DjcIfq__noGamesWrapper",
  "reminder": "sportschedule-module-scss-module__DjcIfq__reminder",
  "scheduleContainer": "sportschedule-module-scss-module__DjcIfq__scheduleContainer",
  "small": "sportschedule-module-scss-module__DjcIfq__small",
  "textStyling": "sportschedule-module-scss-module__DjcIfq__textStyling",
  "timeZone": "sportschedule-module-scss-module__DjcIfq__timeZone",
  "ymmButton": "sportschedule-module-scss-module__DjcIfq__ymmButton",
});
